import cookie from './lib/cookie';
import ConfigSetup from './lib/configSetup';
const config = {
  nameSpace: 'se_',
  cookieNameSpace: 'fe_se',
  maxWeight: 2
};

const configSetupNameSpace = ConfigSetup.nameSpace;
const regNameSpaceReplace = new RegExp(`^(${config.nameSpace})?([\\s\\S]+)$`);
const regDate = /^\d{4}([-/])\d{2}\1\d{2}(\s\d{2}(:\d{2})?(:\d{2})?)?$/;

class LocalStorage {
  getFullName(name) { return name.replace(regNameSpaceReplace, `${config.nameSpace}$2`); }
  getCookieSessionTime() {
    const time = cookie.get(config.cookieNameSpace);
    if (time) {
      return time;
    }
    const now = Date.now();
    cookie.set(config.cookieNameSpace, -now, false, '/');
    return now;
  }
  getExpiredTime(days) {
    if (!days || days < 0) {
      return this.getCookieSessionTime();
    } else if (regDate.test(days)) {
      const time = new Date(days.replace(/[-]/g, '/')).getTime();
      if (!time) {
        throw Error('Invalid Date');
      }
      return time;
    }
    return Date.now() + parseFloat(days) * 24 * 60 * 60 * 1000;
  }
  set(name, value, days, weight = 0) {
    this.removeExpired(false);
    const fullName = this.getFullName(name);
    const data = {
      w: parseFloat(weight),
      v: typeof value === 'object' ? JSON.stringify(value) : value,
      e: this.getExpiredTime(days),
    };
    const dataString = JSON.stringify(data);
    const prevData = this.dir(fullName);

    const fn = (inTry = 0)=> {
      try {
        localStorage.setItem(fullName, dataString);
        const configSetup = new ConfigSetup();
        configSetup.addLength(dataString.length + fullName.length - (prevData ? prevData.length : 0));
        const gcTime = configSetup.getGcTime();
        if (!gcTime || gcTime > data.e) {
          configSetup.setGcTime(data.e);
        }
        configSetup.save();
      } catch (e) {
        if (inTry !== true) {
          if(inTry >= config.maxWeight){
            this.clear();
            inTry = true;
          } else {
            this.clear4Weight(inTry);
            inTry++;
          }
          fn(inTry);
        } else {
          throw Error(e);
        }
      }
    }
    fn();
  }
  dir(name) {
    const fullName = this.getFullName(name);
    const val = localStorage.getItem(fullName);
    if (!val || name === configSetupNameSpace) {
      return null;
    }
    try {
      return {
        length: val.length + fullName.length,
        ...JSON.parse(val),
      }
    } catch(e) {
      return null;
    }
  }
  get(name) {
    const result = this.dir(name);
    if (result) {
      if (
        (result.e < 0 && result.e === this.getCookieSessionTime()) ||
        result.e > Date.now()
      ) {
        try {
          const formatVal = JSON.parse(result.v);
          if (typeof formatVal === 'object') {
            return formatVal;
          }
        } catch (e) {

        }
        return result.v;
      }
    }
    return null;
  }
  getSize() {
    this.removeExpired();
    return new ConfigSetup().getLength();
  }
  remove(name) {
    const fullName = this.getFullName(name);
    const result = this.dir(fullName);
    if (result) {
      const configSetup = new ConfigSetup();
      configSetup.addLength(-result.length);
      configSetup.save();
    }
    localStorage.removeItem(fullName);
  }
  clear() { localStorage.clear(); }
  each(fn, fn2) {
    for (const key of Object.keys(localStorage.valueOf())) {
      const item = this.dir(key);
      if (item) {
        if (fn(key, item) === false) {
          break;
        }
      } else if (fn2) {
        if (fn2(key) === false) {
          break;
        }
      }
    }
  }
  removeExpired(immediate = true) {
    const now = Date.now();
    const configSetup = new ConfigSetup();
    const gcTime = configSetup.getGcTime();

    if (immediate === true || !gcTime || now > gcTime) {
      const cookieSession = this.getCookieSessionTime();
      let minTime;
      configSetup.clear();
      this.each((key, val) => {
        if (
          (val.e < 0 && val.e !== cookieSession) ||
          (val.e > 0 && now > val.e)
        ) {
          localStorage.removeItem(key);
        } else {
          if (!minTime || val.e < minTime) {
            minTime = val.e;
          }
          configSetup.addLength(val.length);
        }
      });
      configSetup.setGcTime(minTime);
      configSetup.save();
    }
  }
  clear4Weight(weight = 0) {
    const configSetup = new ConfigSetup();
    let total = 0;
    const now = Date.now();
    const cookieSession = this.getCookieSessionTime();
    this.each(
      (key, val) => {
        const { w, e } = val;
        if (e === cookieSession) {
          return;
        } else if (now > e || w === 0) {
          total += val.length;
          localStorage.removeItem(key);
        }
      },
      key => {
        localStorage.removeItem(key);
      }
    );
    configSetup.addLength(-total);
    configSetup.save();
  }
}

const sweet = new LocalStorage();

export default sweet;
